var LoaderContext = (function () {
    function LoaderContext(checkPolicyFile, applicationDomain, securityDomain) {
        if (checkPolicyFile === void 0) { checkPolicyFile = false; }
        if (applicationDomain === void 0) { applicationDomain = null; }
        if (securityDomain === void 0) { securityDomain = null; }
        this._applicationDomain = applicationDomain;
    }
    Object.defineProperty(LoaderContext.prototype, "applicationDomain", {
        get: function () {
            return this._applicationDomain;
        },
        set: function (value) {
            this._applicationDomain = value;
        },
        enumerable: true,
        configurable: true
    });
    return LoaderContext;
}());
export { LoaderContext };
